var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4601 47.56C44.6662 47.56 54.6127 37.6357 54.6127 25.4075C54.6127 13.2015 44.6662 3.255 32.4601 3.255C20.2319 3.255 10.3076 13.2015 10.3076 25.4075C10.3076 37.4285 19.8984 47.223 31.8404 47.5515L32.4601 47.56Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1014 15.8985C40.9206 15.718 40.695 15.5888 40.4478 15.5243C40.2006 15.4597 39.9406 15.4623 39.6947 15.5315L22.9543 20.2532C22.6726 20.3326 22.4219 20.4961 22.2356 20.7219C22.0494 20.9476 21.9365 21.2248 21.912 21.5164C21.8875 21.8081 21.9527 22.1002 22.0987 22.3538C22.2447 22.6075 22.4646 22.8105 22.7291 22.9358L29.731 26.2524L34.518 21.4654C34.6528 21.3305 34.8357 21.2548 35.0263 21.2548C35.2169 21.2548 35.3998 21.3305 35.5346 21.4654C35.6694 21.6002 35.7451 21.783 35.7451 21.9736C35.7451 22.1643 35.6694 22.3471 35.5346 22.4819L30.7475 27.269L34.0642 34.2708C34.1791 34.5172 34.362 34.7255 34.5915 34.8712C34.821 35.0169 35.0874 35.0939 35.3592 35.0931C35.4003 35.0931 35.4418 35.0914 35.4835 35.0879C35.7757 35.0651 36.0537 34.9527 36.2797 34.7662C36.5057 34.5798 36.6688 34.3282 36.7468 34.0457L41.4684 17.3053C41.5376 17.0593 41.5401 16.7994 41.4756 16.5521C41.4111 16.3049 41.2819 16.0793 41.1014 15.8985Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -2.71264,
    y: -9.76525,
    width: 70.3456,
    height: 70.3456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.51013
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.50006,
    y1: -2.00012,
    x2: 9.99994,
    y2: 44.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DE1E",
    stopOpacity: 0.41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.21b38aaa831b9352f5306050a9c18fb1.svg";
export { ForwardRef as ReactComponent };